import { FC } from "react";

import "./TrackingHistory.scss";
import TrackingHistoryItem, { TrackingHistoryItemProps } from "../TrackingHistoryItem/TrackingHistoryItem";
import { getLineIconType, getLineType } from "./trackingHistoryUtils";

type TrackingHistoryProps = {
  history: TrackingHistoryItemProps[];
};

const TrackingHistory: FC<TrackingHistoryProps> = function (props) {
  const { history } = props;

  return (
    <div className="tracking-history">
      {history.map(
        (
          {
            date,
            message,
            modeOfTransportation,
            modeOfTransportationName,
            terminal,
            location,
            exceptionProps,
            event_piece,
            event_weight,
          },
          index,
        ) => {
          const showLine = index !== history.length - 1;
          const lineType = getLineType(index, history);
          const lineIconType = getLineIconType(index, history);

          return (
            <div key={index} className="tracking-history__item">
              <div className={`tracking-history__icon tracking-history__icon--${lineIconType}`} />
              {showLine && <div className={`tracking-history__line tracking-history__line--${lineType}`} />}
              <TrackingHistoryItem
                date={date}
                message={message}
                modeOfTransportation={modeOfTransportation}
                modeOfTransportationName={modeOfTransportationName}
                terminal={terminal}
                location={location}
                exceptionProps={exceptionProps}
                event_piece={event_piece}
                event_weight={event_weight}
              />
            </div>
          );
        },
      )}
    </div>
  );
};

export default TrackingHistory;
